export let currentLocale: string | null = null;

export const setCurrentLocale = (cLocale: string): void => {
  if (cLocale) {
    currentLocale = cLocale;
  } else {
    global.log.debug("[setCurrentLocale] could not set currentLocale (page.locale is not set)");
  }
};
